<template>
  <v-app>
    <v-main>
      <div class="page-content">
        <keep-alive>
          <router-view v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive"></router-view>
      </div>
      <ComplianceFooter />
    </v-main>
  </v-app>
</template>

<script>
import ComplianceFooter from "./components/ComplianceFooter.vue";

export default {
  name: "App",
  components: {
    ComplianceFooter,
  },
  methods: {},
};
</script>

<style scoped>
.page-content {
  padding-bottom: 44px;
}
</style>
